<ion-grid class="confirmation-body">
  <div *ngIf="popupName == 'Quarterly Vs YTD'">
    <ion-row>
      <ion-col size-sm="7" size-md="7" size-lg="7" size-xs="7">
       <div class="verticle-center">
        <div class="fs-18 font_bold cl-black">{{moduleName}}&nbsp;({{totalCount}})</div>
        <div *ngIf="loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'HR Admin' || 
        loggedInUserRole == 'Admin' || loggedInUserRole == 'HOD' || loggedInUserRole == 'HOD' || loggedInUserRole == 'Manager'">
          <div *ngIf="currentTabName == 'myhome'">
            <mat-form-field class="mat-height40 mat-input-style pl-10">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput type="search" placeholder="Search with ID/ Name" [(ngModel)]="searchEmployee"
              (input)="onEmployeeSearch(searchEmployee)"
                  >
            </mat-form-field>
          </div>
        </div> 
       </div>
      </ion-col>
      <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="text-right">
        <div class="center-content justify-content-flex-end">
          <label class="mr-10" *ngIf="this.moduleName == 'My Approved Status' || this.moduleName == 'Manager Approval Status'">Rejected</label>
          <label class="mr-10" *ngIf="this.moduleName == 'Goal Setting Status' || this.moduleName == 'Goal Review Status' ||
          moduleName=='My Goal Setting Status' || moduleName=='My Goal Review Status'">Incomplete</label>
          <mat-slide-toggle class="mr-10" *ngIf="moduleName != 'Active Employee' && moduleName != 'Exited Employee'" [(ngModel)]="isToggleOn" (change)="onChangeSwitch($event)"></mat-slide-toggle>
          <label class="mr-10" *ngIf="this.moduleName == 'My Approved Status' || this.moduleName == 'Manager Approval Status'">Approved</label>
          <label class="mr-10" *ngIf="this.moduleName == 'Goal Setting Status' || this.moduleName == 'Goal Review Status' ||
          moduleName=='My Goal Setting Status' || moduleName=='My Goal Review Status'">Complete</label>         
          <button (click)="exportDashboardListExcel()" class="mr-10 Download fs-16 font_semibold"><img src="././assets/icon/yellowdownload.png"
            class="downIcon">Download</button>
            <div class="close_bg display-center cp" [mat-dialog-close]>
              <img src="././assets/icon/close_icon.png" class="closeHeight">
            </div>
        </div>
      </ion-col>
      <!-- <ion-col size-sm="1" size-md="1" size-lg="1" size-xs="1" -->
        <!-- *ngIf="moduleName != 'Active Employee' && moduleName != 'Exited Employee'" style="padding: 13px;float:right;"> -->
        <!-- <mat-slide-toggle [(ngModel)]="isToggleOn" (change)="onChangeSwitch($event)"></mat-slide-toggle> -->

        <!-- <div class="slider-container">
          <input type="checkbox" id="slider-checkbox" style="display: none;" (change)="onChangeSwitch($event)">
          <label class="slider" for="slider-checkbox"></label>
        </div> -->
      <!-- </ion-col> -->

      <!-- <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
        <button class="Download fs-16 font_semibold"><img src="././assets/icon/yellowdownload.png"
            class="downIcon">Download</button>
      </ion-col>
      <ion-col size-sm="1" size-md="1" size-lg="1" size-xs="1">
        <div class="close_bg display-center cp" [mat-dialog-close]>
          <img src="././assets/icon/close_icon.png" class="closeHeight">
        </div>
      </ion-col> -->
    </ion-row>

    <ion-row *ngIf="moduleName == 'Active Employee'">
      <ion-col class="p-10" size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="table-scroll">
          <table>
            <tr>
              <th>Employee Code</th>
              <th>Employee Name</th>
              <th>Gender</th>
              <th>Date Of Joining</th>
              <th>Company name</th>
              <th>Official Email</th>
              <th>Dotted Reporting Manager Name</th>
              <th>HOD Name</th>
              <th>Band</th>
              <th>Grade</th>
              <th>Designation</th>
              <th>Department</th>
              <th>Plant/Office Location</th>
            </tr>
            <tr *ngFor="let item of activeEmployeeList">
              <td (click)="onClickGoToEmployeeMasterPage(item.id)" class="cp">{{item?.employeeId}}</td>
              <td>{{item?.firstName}}&nbsp;{{item?.lastName}}</td>
              <td>{{item?.gender}}</td>
              <td>{{item?.dateOfJoining | date: 'dd-MM-yyyy'}}</td>
              <td>{{item?.companyName}}</td>
              <td>{{item?.officialEmail}}</td>
              <td>{{item?.dottedReportingManagerName}}</td>
              <td>{{item?.hodName}}</td>
              <td>{{item?.band}}</td>
              <td>{{item?.grade}}</td>
              <td>{{item?.designation}}</td>
              <td>{{item?.department}}</td>
              <td>{{item?.workLocationCity}}</td>
            </tr>
          </table>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="moduleName == 'Goal Setting Status'">
      <ion-col>
        <div class="table-scroll">
          <table>
            <tr>
              <th>Emp. ID</th>
              <th>Emp Name</th>
              <th>Department</th>
              <th>Manager</th>
              <th>Review Cycle</th>
              <th>Location</th>
              <th>WT</th>
              <th>Goal Setting status</th>
            </tr>
            <tr *ngFor="let item of goalSettingList">
              <td>{{item?.empId}}</td>
              <td>{{item?.empName}}</td>
              <td>{{item?.department}}</td>
              <td>{{item?.manager}}</td>
              <td>{{sharedService.transform(item?.reviewCycle)}}</td>
              <td>{{item?.location}}</td>
              <td>{{item?.wt}}</td>
              <td [ngStyle]="{ 'background-color': item.goalSettingStatus ? '#C0E7C5' : '#FADCDC' }">{{
                item.goalSettingStatus ? 'Complete' : 'Incomplete' }}</td>
            </tr>
          </table>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="moduleName == 'Goal Review Status'">
      <ion-col>
        <div class="table-scroll">
          <table>
            <tr>
              <th>Emp. ID</th>
              <th>Emp Name</th>
              <th>Department</th>
              <th>Manager</th>
              <th>Review Cycle</th>
              <th>Location</th>
              <th>Score</th>
              <th>Goal Review status</th>
              <th>MIS</th>
            </tr>
            <tr *ngFor="let item of goalReviewStatusList">
              <td>{{item?.empId}}</td>
              <td>{{item?.empName}}</td>
              <td>{{item?.department}}</td>
              <td>{{item?.manager}}</td>
              <td>{{sharedService.transform(item?.reviewCycle)}}</td>
              <td>{{item?.location}}</td>
              <td>{{item?.kpiScore}}</td>
              <td [ngStyle]="{ 'background-color': item.goalReviewStatus=='Complete' ? '#C0E7C5' : '#FADCDC' }">{{
                item.goalReviewStatus }}</td>
              <td>{{item?.mis}}</td>
            </tr>
          </table>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="moduleName == 'Manager Approval Status'">
      <ion-col>
        <div class="table-scroll">
          <table>
            <tr>
              <th>Emp. ID</th>
              <th>Emp Name</th>
              <th>Department</th>
              <th>Manager</th>
              <th>Review Cycle</th>
              <th>Location</th>
              <th>Total KPIs</th>
              <th>Approved by Manager</th>
            </tr>
            <tr *ngFor="let item of managerApprovalData">
              <td>{{item?.empId}}</td>
              <td>{{item?.empName}}</td>
              <td>{{item?.department}}</td>
              <td>{{item?.manager}}</td>
              <td>{{sharedService.transform(item?.reviewCycle)}}</td>
              <td>{{item?.location}}</td>
              <td><span style="color: #33B060;">A:</span>{{item.totalApproved}}&nbsp;&nbsp;&nbsp;<span
                style="color: #E94848;">R</span>:{{item.totalRejected}}</td>
              <td [ngStyle]="{ 'background-color': item.managerApproval=='Approved' ? '#C0E7C5' : '#FADCDC' }">
                {{item.managerApproval=='Approved' ? 'Approved' : 'Rejected' }}</td>
            </tr>
          </table>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="moduleName == 'Exited Employee'">
      <ion-col>
        <div class="table-scroll">
          <table>
            <tr class="font_semibold ">
              <th>Employee Code</th>
              <th>Employee Name</th>
              <th>Gender</th>
              <th>Date Of Joining</th>
              <th>Company name</th>
              <th>Official Email</th>
              <th>Dotted Reporting Manager Name</th>
              <th>HOD Name</th>
              <th>Band</th>
              <th>Grade</th>
              <th>Designation</th>
              <th>Department</th>
              <th>Plant/office Location</th>
              <th>LWD</th>
              <th>Date of Resignation</th>
            </tr>
            <tr *ngFor="let item of exitedEmployeeRecord" class="font_regular ">
              <td>{{item.employeeId}}</td>
              <td>{{item.firstName}}&nbsp;{{item.lastName}}</td>
              <td>{{item.gender}}</td>
              <td>{{item.dateOfJoining | date: 'dd-MM-yyyy'}}</td>
              <td>{{item.companyName}}</td>
              <td>{{item.officialEmail}}</td>
              <td>{{item.dottedReportingManagerName}}</td>
              <td>{{item.hodName}}</td>
              <td>{{item.band}}</td>
              <td>{{item.grade}}</td>
              <td>{{item.designation}}</td>
              <td>{{item.department}}</td>
              <td>{{item.workLocationCity}}</td>
              <td>{{item.dateOfExit | date: 'dd-MM-yyyy'}}</td>
              <td>{{item.dateOfResignation | date: 'dd-MM-yyyy'}}</td>
            </tr>
          </table>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="moduleName == 'My Goal Setting Status'">
      <ion-col>
        <div class="table-scroll">
          <table>
            <tr class="font_semibold ">
              <th>Employee ID</th>
              <th>Employee Name</th>
              <th>Department</th>
              <th>Review Cycle</th>
              <th>Location</th>
              <th>WT</th>
              <th>My Goal Setting Status</th>
              <th>MIS</th>
            </tr>
            <tr *ngFor="let item of myGoalSettingStatus" class="font_regular ">
              <td>{{item.empId}}</td>
              <td>{{item.empName}}</td>
              <td>{{item.department}}</td>
              <td>{{sharedService.transform(item?.reviewCycle)}}</td>
              <td>{{item.location}}</td>
              <td>{{item.wt}}</td>
              <td [ngStyle]="{ 'background-color': item.goalSettingStatus ? '#C0E7C5' : '#FADCDC' }">
                {{item.goalSettingStatus ? 'Complete' : 'Incomplete' }}</td>
              <td>{{item.mis}}</td>
            </tr>
          </table>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="moduleName == 'My Goal Review Status'">
      <ion-col>
        <div class="table-scroll">
          <table>
            <tr class="font_semibold ">
              <th>Employee ID</th>
              <th>Employee Name</th>
              <th>Department</th>
              <th>Review Cycle</th>
              <th>Location</th>
              <th>Score</th>
              <th>My Goal Review Status</th>
              <th>MIS</th>
            </tr>
            <tr *ngFor="let item of myGoalReviewStatus" class="font_regular ">
              <td>{{item.empId}}</td>
              <td>{{item.empName}}</td>
              <td>{{item.department}}</td>
              <td>{{sharedService.transform(item?.reviewCycle)}}</td>
              <td>{{item.location}}</td>
              <td>{{item.kpiScore}}</td>
              <td [ngStyle]="{ 'background-color': item.goalReviewStatus=='Complete' ? '#C0E7C5' : '#FADCDC' }">{{
                item.goalReviewStatus}}</td>
              <td>{{item.mis}}</td>
            </tr>
          </table>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="moduleName == 'My Approved Status'">
      <ion-col>
        <div class="table-scroll">
          <table>
            <tr class="font_semibold ">
              <th>Employee ID</th>
              <th>Employee Name</th>
              <th>Department</th>
              <th>Review Cycle</th>
              <th>Location</th>
              <th>Total KPIs</th>
              <th>Approved by Manager</th>
            </tr>
            <tr *ngFor="let item of myApprovedStatus" class="font_regular ">
              <td>{{item.empId}}</td>
              <td>{{item.empName}}</td>
              <td>{{item.department}}</td>
              <td>{{sharedService.transform(item?.reviewCycle)}}</td>
              <td>{{item.location}}</td>
              <td><span style="color: #33B060;">A:</span>{{item.totalApproved}}&nbsp;&nbsp;&nbsp;<span
                  style="color: #E94848;">R</span>:{{item.totalRejected}}</td>
              <td [ngStyle]="{ 'background-color': item.managerApproval=='Approved' ? '#C0E7C5' : '#FADCDC' }">{{
                item.managerApproval=='Approved' ? 'Approved' : 'Rejected' }}</td>
            </tr>
          </table>
        </div>
      </ion-col>
    </ion-row>
  </div>



  <div *ngIf="popupName == 'Company Score Trend'">
    <ion-row>
      <ion-col size="11">
        <div class="fs-18 font_bold cl-black">{{compnayScoreNameOfperson}}</div>
      </ion-col>
      <ion-col size="1">
        <div class="close_bg display-center cp" [mat-dialog-close]>
          <img src="././assets/icon/close_icon.png">
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="9">
      </ion-col>
      <ion-col size="3">
        <ion-row>
          <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2" class="cp">
            <div (click)="setChartType('bar')">
              <img src="././assets/icon/barChartIcon.svg" *ngIf="kpiScoreSummaryGraphType!='bar'">
              <img src="././assets/icon/activeBarChart.svg"  *ngIf="kpiScoreSummaryGraphType=='bar'">
            </div>
          </ion-col>
          <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2" class="cp">
            <div (click)="setChartType('line')">
              <img src="././assets/icon/lineChartIcon.svg" *ngIf="kpiScoreSummaryGraphType!='line'">
              <img src="././assets/icon/activeLineChart.svg" *ngIf="kpiScoreSummaryGraphType=='line'">
            </div>
          </ion-col>
          <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2" class="cp">
            <div (click)="setChartType('pie')">
              <img src="././assets/icon/pieChartIcon.svg" *ngIf="kpiScoreSummaryGraphType!='pie'">
              <img src="././assets/icon/activePieChartIcon.svg" *ngIf="kpiScoreSummaryGraphType=='pie'">
            </div>
          </ion-col>
          <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2" class="cp">
            <div (click)="setChartType('area')">
              <img src="././assets/icon/area.svg" *ngIf="kpiScoreSummaryGraphType!='area'">
              <img src="././assets/icon/areaChart.svg" *ngIf="kpiScoreSummaryGraphType=='area'">
            </div>
          </ion-col>
          <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
            <img class="cp" (click)="pmsDashboardGraphDownloadScoreTrend()" src="././assets/icon/downloadIcon.svg">
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>


    <ion-row>
      <ion-col size="12">
        <div class="graphDiv">
          <div id="companyscoreTrendReport" style="width: 800px; height: 400px;"></div>
        </div>
      </ion-col>
    </ion-row>
  </div>
</ion-grid>